import { forwardRef, PropsWithChildren } from "react"

const MusinsaRegistrationTerm = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => {
  return (
    <div
      ref={ref}
      className="flex h-full flex-col gap-y-2 overflow-y-scroll text-sm"
    >
      <h4 className="text-xl">
        <strong>회원가입 및 물품 운송 이용약관</strong>
      </h4>

      <p>
        <br />본 약관은 무신사 납품 셀러(이하”갑”이라 한다)에 대해 주식회사
        브이투브이(이하”을”이라 한다)가 제공하는 서비스 및 서비스 이용
        과정에서의 상호 관계를 설명하며, 서비스 이용을 위해 아래의 약관 및 관련
        운영 정책에 동의하여야 합니다.
        <br />
      </p>

      <p className="mt-1">
        <strong>제 1 조 (목적)</strong>
        <br />
      </p>
      <p>
        본 계약은 “갑”으로부터 “을”이 물품 운송 용역을 의뢰받아 “을”의 책임하에
        “갑”이 지정하는 송하인 및 그 대리인 (이하 “화주”라 한다)의 물품을 “갑”이
        지정한 장소 (이하 “입고지”라 한다)에 운송하기까지의 제반 업무에 관한
        사항과 배송요금의 지급 및 청구권 등을 정하는 데 그 목적이 있다.
        <br />
      </p>

      <p className="mt-1">
        <strong>제 2 조 (업무 범위 및 업무형태)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          “을”은 “갑”의 출고지에서 물품을 수령한 뒤, 해당 물품들을 익일 오전
          2시까지 입고지로 운송한다. 1.1. 계약일 현재 입고지는 ‘경기 여주시
          대신면 여양로 1305 A동 1층’이며, 해당 장소가 변경될 경우 운송 마감시간
          및 운영형태 등을 추후 지정한다. 1.2. “을”은 배송 마감시간을 준수하여야
          하며, 이에 대한 귀책 및 면책, 배상은 제 5조와 6조를 따른다.
        </li>
        <li>
          해당 서비스는 반품서비스를 지원하지 않으며, 반품이 필요할 경우 “갑”이
          무신사에 요청하여 상호 합의하에 수행한다.
        </li>
        <li>
          업무의 원활한 수행을 위해, “을”은 차량의 수배 및 관리를 수행하며, 운송
          현장에서의 “갑”에 대한 운송기사들의 서비스 품질관리를 수행한다.
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 3조 (운송 물품의 정의 및 제한)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          1톤 차량 1대 기준으로 상하차 장비 없이 적재 가능하며 법적으로
          일반화물운송사업자가 운송할 수 있는 모든 물품을 그 대상으로 한다.
        </li>
        <li>
          운송기사의 상하차가 가능한 물품의 경우 상하차 의무는 원칙적으로 “을”의
          운송기사에게 있다. 다만 파렛트 합포장 형태, 박스 형태가 아닌 화물,
          특수화물, 합포장 박스 1EA 당 20kg을 초과하는 중량물 등 상하차 지원이
          필요한 물품인 경우 출고지와 입고지에서 해당 장비 및 상하차 운용을
          지원해야 하며, “갑”이 이를 이행하지 않을 시 “을”은 해당 물품에 대한
          운송을 거부할 수 있다.
        </li>
        <li>
          의약품, 도검류, 특수화물 등 운송에 특정한 자격요건이 추가로 필요한
          물품은 서비스 대상에서 제외한다.
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 4조 (운송대금 및 정산방식)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          운송대금, 물량 과다 시 추가 차량 대금, 지불 기한, 지불 방식 등 결제
          관련 사항은 “갑”과 무신사가 별도의 계약을 체결하여 정한다.{" "}
        </li>
        <li>
          “갑”이 “을”과 직접 대금 정산 및 지불을 수행하는 형태로 합의될 경우, 본
          약관과 별도의 운송계약서를 체결한 후 그에 따른다.
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 5조 (주문 및 출고시기)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          “갑”은 운송 주문을 운송일 오전 11시까지 “을”이 제공하는 전산시스템을
          통해 신청하여야 하며, 11시 이후 신청된 주문건에 대해서 “을”은 주문
          당일 픽업하지 않을 수 있다.
        </li>
        <li>
          “갑”은 주문 신청한 운송 물품에 대하여 운송일 오후 12시 (정오) 까지
          “을”이 제공하는 운송장이 부착된 상태로 지정된 출고 장소에 출고해야
          하며, “을”의 운송기사가 출고 장소에 도착하였을 때 출고되어있지 않거나
          운송장이 부착되어 있지 않은 주문건은 주문 당일 픽업하지 않을 수 있다.
        </li>
        <li>
          본조 1항 및 2항에 기재된 “갑”의 업무 지연으로 인해 당일 픽업이
          불가능할 시, “을”은 익영업일에 해당 물품의 픽업을 수행한다.
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 6 조 (물품 손해 배상)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          “갑”은 “을”이 물품의 수탁, 인도 보관 및 운송에 관하여 주의를 태만히
          하여 “갑”에게 물품의 멸실, 훼손 등의 손해가 발생한 경우 “을’에게 그
          손해의 배상을 청구할 수 있다.
        </li>
        <li>
          “을”의 귀책사유에 의한 물품의 손상으로 인하여 “갑”이 입은 손해에
          대하여는 제품 원가(공장도가)를 기준으로 “을”이 전액 배상함을 원칙으로
          한다.
        </li>
        <li>
          “갑”은 손해 발생 인지 후 1주일 이내에 배상청구를 하도록 하며, “을”은
          배상액 확정일로부터 14일 이내에 이를 배상하여야 한다.
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 7 조 (면책)</strong>
      </p>
      <p>“을”은 다음 각 호에 해당하는 경우에는 그 책임을 면한다.</p>
      <ol className="list-inside list-decimal">
        <li>
          폭우, 폭설 등 천재지변, 기타 소요사태로 인한 배달지연 등의 물품사고가
          발생한 경우
        </li>
        <li>
          “갑” 또는 “갑”의 수하인이 배송 후 화물의 일부 멸실 또는 훼손 등의
          사고가 발생한 사실을 인지한 후 14일 이내에 “을”에게 알리지 아니한 경우
        </li>
        <li>
          의뢰하는 물품의 종류와 성질, 중량, 용적 등이 계약내용과 달리
          변경되었음을 사전에 “을”에게 통지하지 아니하여 그로 인해 손해가 발생된
          경우
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 8조 (약관 유효기간)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>본 이용약관은 회원 탈퇴시까지 유효하다.</li>
      </ol>

      <p className="mt-1">
        <strong>제 9 조 (비밀보장)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          “을”은 물품 운송 업무를 수행하는 과정에서 알게 된 “상호”의 정보 및
          기밀 사항을 엄수하고, “상호”의 기업 이미지 및 품위를 손상하는 일이
          없도록 최선을 다한다.
        </li>
        <li>
          양 사 간 합의 및 계약된 서비스 운임, 서비스 조건 등의 영업 비밀
          사항들에 대해 “상호”는 외부 유출 또는 제 3자와 정보 공유를 할 수
          없으며, 관련 정보에 대한 보안 및 관리 책임을 진다. 단, 다음의 경우에는
          제3자와 정보공유를 수행할 수 있다. 단 아래의 경우에는 예외로 둘 수
          있다.
          <ol className="list-inside pl-2" style={{ listStyleType: "hangul" }}>
            <li>서비스 제공에 따른 요금 정산을 위하여 필요한 경우</li>
            <li>
              통계작성·학술연구 또는 시장조사를 위하여 필요한 경우로서 특정
              개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
            </li>
            <li>
              금융실명거래및비밀보장에관한법률, 신용정보의이용및보호에관한법률,
              전기통신기본법, 전기통신사업법, 지방세법, 소비자보호법,
              한국은행법, 형사소송법 등 법률에 특별한 규정이 있는 경우
            </li>
            <li>
              기타 개인정보 보호와 관련된 사항은 회사의 “개인정보 취급방침”에
              따른다.
            </li>
          </ol>
        </li>
        <li>
          “갑”과 “을” 중 어느 한 쪽이 제2항을 위반할 경우 은 이로 말미암아
          발생한 영업 손실에 대해 상대방은 금전적 배상을 요구할 권리를 가지며,
          위반 당사자는 이를 수용하고 즉각 배상하여야 한다.
        </li>
      </ol>

      <p className="mt-1">
        <strong>제 10 조 (분쟁 해결)</strong>
      </p>
      <ol className="list-inside list-decimal">
        <li>
          본 계약에 명시되지 아니한 사항은 운송표준약관에 기반해 상호 협의하여
          해결하기로 한다.
        </li>
        <li>
          본 계약에 관하여 분쟁이 있는 경우에는 을의 소재지를 관할하는 법원을
          제1심의 전속관할로 한다.
        </li>
      </ol>

      <p className="underline decoration-2">
        <a
          href="https://www.amazing.today/privacy"
          target="_blank"
          rel="noreferrer"
        >
          <strong>개인정보 처리 방침</strong>
        </a>
      </p>
    </div>
  )
})

MusinsaRegistrationTerm.displayName = "MusinsaRegistrationTerm"

export { MusinsaRegistrationTerm }
